import React, { useState } from "react";
import * as XLSX from "xlsx";
import axios from "../../../utils/axios";
import useFetch from "../../../hooks/useFetch";
import TableLoading from "../../../components/ui/loader/TableLoading";
import moment from "moment/moment";
import donations from "../../../data/donations"

const mosjidName = process.env.REACT_APP_MOSJID_NAME;

const getDonationName = (donationName) =>{
  const donation = donations.find((d)=>d.title?.toLowerCase() === donationName?.toLowerCase());
  return donation ? donation.authorTitle : donationName;
}

const ItemWisePaymentList = ({ title, tableHeader, url, exportDate }) => {
  const { loading, data } = useFetch(url);

  if (loading) {
    return (
      <div>
        <p className="text-sm font-medium sm:ml-8 lg:text-lg">{title}</p>
        <div className="mt-4 w-full px-1 py-1 bg-custom-dodger-blue-100 rounded-md overflow-x-auto relative">
          <TableLoading header={tableHeader} />
        </div>
      </div>
    );
  }

  // const newDonationList = donations.map((donation) => {
  //   const { title, authorTitle } = donation || {};
  //   const updatedDonation = data?.find((element) => {
  //     return element.name.toLowerCase() === title.toLowerCase();
  //   });
  //   const { amount, transactionNo, name } = updatedDonation || {};
  //   return { title, authorTitle, name, amount, transactionNo };
  // });

  return (
    <div>
      <p className="mb-4 text-sm font-medium sm:ml-8 lg:text-lg">{title}</p>
      <div className="w-full px-1 py-1 bg-custom-dodger-blue-100 rounded-xl overflow-x-auto relative">
        <table className="w-full border-separate border-spacing-2">
          <thead className="text-xs capitalize text-left">
            <tr>
              {tableHeader.map((th) => (
                <th key={th} scope="col" className="font-normal text-xs">
                  {th}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="text-xs capitalize text-left">
            {data?.map((item) => (
              <tr key={item.name} className="row space-x-3">
                <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                  {getDonationName(item.name)}
                  {/* {donations.find((d)=> d.name?.toLowerCase() === item.name?.toLowerCase()).} */}
                </td>
                <td className="font-normal text-xs px-2 py-2 bg-white rounded-md text-center">
                  {item.transactionNo}
                </td>
                <td className="font-normal text-xs px-2 py-2 bg-white rounded-md">
                  $ {item.amount?.toFixed(2)}
                </td>
                <Export item={item} exportDate={exportDate} />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ItemWisePaymentList;

const Export = ({ item, exportDate }) => {
  const [pending, setPending] = useState(false);

  const exportHandler = async (itemName) => {
    try {
      setPending(true);
      const url = `/payment/${mosjidName}/${itemName}/list?startDate=${exportDate.startDate}&endDate=${exportDate.endDate}`;
      const { data } = await axios.get(url);

      const tempData = data?.map((payment) => ({
        Ref_ID: payment.referenceId,
        Status: payment.status,
        Amount: payment.amount,
        Date: moment(payment.date).format("MMM Do YY"),
        Email_Address: payment.email,
        Contact: payment.contactNumber,
        E_receipt: payment.receipt,
        Card_Type: payment.cardType,
        // Items_LIST: payment.items.map((item) => item.name),
      }));

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(tempData);
      XLSX.utils.book_append_sheet(wb, ws, "my-sheet1");
      const fileName = `${getDonationName(itemName)}-${moment(exportDate.startDate).format(
        "MMM Do YY"
      )}-${moment(exportDate.endDate).format("MMM Do YY")}.xlsx`;
      XLSX.writeFile(wb, fileName);

      setPending(false);
    } catch (error) {
      setPending(false);
      console.log("error", error.message);
    }
  };

  return (
    <td className="font-normal text-xs  bg-white rounded-md">
      <button
        type="button"
        className="w-full px-2 py-2"
        disabled={pending}
        onClick={() => exportHandler(item.name)}
      >
        Export
      </button>
    </td>
  );
};
